import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userInfoWrapper: {
    ...theme.mixins.appContainer,
    marginTop: theme.spacing(1),
  },
  userInfoContent: {
    '& > div + div': {
      marginTop: '16px',
    },
    '& > div:first-of-type': {
      marginTop: 0,
    },
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      '& button': {
        width: '100%',
      },
    },
  },

  uploadFileButton: {
    height: '32px',
    lineHeight: '24px',
    padding: '4px 8px',
    display: 'inline-flex',
    marginBottom: '4px',
    '& svg': {
      marginRight: '8px',
    },
  },
  avatarWrapper: {
    paddingBottom: '8px',
    '& img': {
      maxWidth: '100px',
      maxHeight: '100px',
    },
  },
  title: {
    ...theme.mixins.appEllipsis,
    fontWeight: '500',
    fontStyle: 'normal',
    color: theme.palette.grey[600],
    paddingBottom: '4px',
  },
  viewItem: {
    boxShadow: 'none',
    padding: `${theme.spacing(0.5)} 0 !important`,
  },
}));
